import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { EnumCheckApproval } from "@/models/enum/Enum";
import { VChip } from "vuetify/lib";

type Props = {
  value: EnumCheckApproval;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'CheckApprovalChip',
  props: {
    value: null
  },
  setup(__props: any) {

const props = __props as {
  value: EnumCheckApproval;
};



const chip = computed(() => {
  switch (props.value) {
    case EnumCheckApproval.Yes:
      return { text: "確認済", color: "primary" };
    case EnumCheckApproval.No:
      return { text: "未確認", color: "" };
    default:
      return undefined;
  }
});

return { __sfc: true,props, chip, VChip }
}

})